import { Carousel } from "@mantine/carousel"
import { Card, Image, Text, Badge, Group, Flex } from '@mantine/core';
import colors from "../utils/colors";
import { useLanguage } from '../context/LanguageContext';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
import { motion } from "framer-motion";
import { ctaPulse } from "../utils/animations";

const urlToShare = "https://36minut.pl/"

export const ShareToMediaCard: React.FC<{}> = ({ }) => {
  const { translate } = useLanguage();
  
  return (
  <Card shadow="sm" padding="lg" radius="md" c={colors.custom36s} bg={`${colors.custom36p}50`}>
    <Card.Section>
      <Image
        src={'fbshare.jpg'}
        h={160}
        alt="36m"
      />
    </Card.Section>

    <Flex direction={'row'} justify="space-between" mt="md" mb="xs" pl={'xs'} pr={'xs'} align={'center'}>
      <Text fw={700} w={180} fz={'h4'}>{translate('shareToMediaTitle')} !</Text>
      <Badge variant="gradient"
       gradient={{ from: 'blue', to: 'cyan', deg: 90 }}>
      {translate('media')}</Badge>
    </Flex>

    <Text size="sm" c={colors.custom36s} fw={500} pl={'xs'} pr={'xs'} fz={'h5'}>
      {translate('shareToMediaDescription')}
    </Text>

    <motion.div 
        animate="animate" 
        variants={ctaPulse}
        className="text-center"
    >
      <Flex direction={'row'} gap={'xs'} px={'sm'} pt={'xs'} align={'center'} justify={'center'}>
        <FacebookShareButton url={urlToShare} hashtag="#36MINUT">
          <FacebookIcon size={30} round={true}/>
        </FacebookShareButton>
        <TwitterShareButton url={urlToShare} title={"36 MINUT"} hashtags={['36MINUT']}>
          <XIcon size={30} round={true}/>
        </TwitterShareButton>
        <LinkedinShareButton url={urlToShare} title={"36 MINUT"}>
          <LinkedinIcon size={30} round={true}/>
        </LinkedinShareButton>
        <WhatsappShareButton url={urlToShare} title={"36 MINUT"}>
          <WhatsappIcon size={30} round={true}/>
        </WhatsappShareButton>
      </Flex>
    </motion.div>

  </Card>)
}

export const CarouselCards: React.FC<{}> = ({ }) => {
    return (
        <Carousel slideSize="100%" height={'max-content'} maw={1000} mah={1000} slideGap="md" controlSize={12} controlsOffset={'6'} styles={{control: {background: `${colors.custom36p}ee`, border: 'none', color: 'white',}}}>
            <Carousel.Slide><ShareToMediaCard/></Carousel.Slide>
        </Carousel>
    )
}